const SUPPORT_EMAIL = 'support@futureproof.app';

export {
    SUPPORT_EMAIL
};
